import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { asyncState, } from '~/hooks';
import { Portal } from '~/components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import Modal from '~/components/Modal';
import {  MdClose } from 'react-icons/md';
import { auth } from '~/api';

const DeleteUser = (props) => {
    const history = useHistory();
    const [status, setStatus] = useState(asyncState.IDLE);

    const deleteUser = async () => {
        try {
            await auth.deleteUser(props.user_id)
                .then(() => {
                    setStatus(asyncState.SUCCESS);
                    history.push('/useradmin');
                })
                .catch((err) =>{
                    console.error(err);
                    setStatus(asyncState.ERROR);
                });
            
            return true;
        } catch (err) {
            console.error(err);
        }
    };


    return(
        <>
            {(status == asyncState.IDLE || status == asyncState.ERROR) &&
            <Modal isModalOpen={props.showDeleteModal} preventScroll className='rounded-md bg-white'>
                <section className='w-full h-full flex flex-col items-stretch justify-start'>
                    <>
                        <header className="border-b-2 text-md flex items-center justify-between py-2 px-4">
                            <p className="font-semibold">Delete Account</p>
                            
                            <button 
                                className="py-2 rounded-full"
                                onClick={props.hideDeleteModal}
                            >
                                <MdClose size="1em" />
                            </button>
                            {status == asyncState.PENDING && (
                                <Portal id="loading-modal">
                                    <div className="flex items-center justify-center h-screen w-screen bg-gray-400 opacity-70 z-50 fixed top-0 left-0 translate-y-1/2 -translate-x-1/2">
                                        <AiOutlineLoading3Quarters className="animate-spin text-blue-30 font-bold" size="4rem" />
                                    </div>
                                </Portal>
                            )}
                        </header>
                
                        <div className='flex items-center justify-center flex-1 p-6'>
                            <div className='grid grid-cols-11 gap-y-4'>
                                
                                <div className='col-span-11 flex flex-col items-center justify-end text-xs'>
                                    <p>Are you sure you want to delete this account?</p>
                                    <div className="flex justify-between">
                                        <button 
                                            className='py-2 px-4 rounded-full border mr-2 focus:outline-none'
                                            onClick={()=>{
                                                props.hideDeleteModal();
                                            }}
                                        >
                                            NO
                                        </button>
                                        <button 
                                            className='py-2 px-4 rounded-full text-red-500 text-sm border-red-500 border-2'
                                            onClick={() => {
                                                setStatus(asyncState.PENDING);
                                                deleteUser();
                                            }}
                                        >
                                            YES
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </section>
            </Modal>
            }
        </>
    );
};

export default DeleteUser;